import { render } from "./VueResizer.vue?vue&type=template&id=115864fa"
import script from "./VueResizer.vue?vue&type=script&lang=js"
export * from "./VueResizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__